import script from "./VerifiedJobCard.vue?vue&type=script&setup=true&lang=js"
export * from "./VerifiedJobCard.vue?vue&type=script&setup=true&lang=js"

import "./VerifiedJobCard.vue?vue&type=style&index=0&id=610de662&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-610de662"]])

export default __exports__